import { createTheme as createMuiTheme } from '@mui/material';
import { createPalette } from './create-palette';
import { createComponents } from './create-components';
import { createShadows } from './create-shadows';
import { createTypography } from './create-typography';

export function createTheme() {
  const palette = createPalette();
  const components = createComponents({ palette });
  const shadows = createShadows();
  const typography = createTypography();

  return createMuiTheme({
    typography,
    breakpoints: {
      values: {
        xs: 340,
        sm: 600,
        md: 1280,
        lg: 1920,
        xl: 2400
      }
    },
    components,
    palette,
    shadows,
    shape: {
      borderRadius: 0
    },
 
  });
}
